import { render, staticRenderFns } from "./Block3.vue?vue&type=template&id=00c4aa40&scoped=true&"
import script from "./Block3.vue?vue&type=script&lang=js&"
export * from "./Block3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4aa40",
  null
  
)

export default component.exports